import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.921 8.333c.367.75.521 1.396.521 1.667 0 .833-1.458 5.208-6.042 5.208-.61 0-1.163-.077-1.666-.213m-2.5-1.438C4.869 12.224 4.359 10.493 4.359 10c0-.833 1.458-5.208 6.041-5.208 1.496 0 2.659.465 3.547 1.122m2.495-1.956L4.36 16.042" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9.075 11.326a1.875 1.875 0 1 1 2.651-2.652" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);